module.exports = __webpack_public_path__ + "static/media/banner_1.7add5ba2.jpg";